<template>
  <sa-page-layout :btnRouterBackVisible="true" :btnBackVisible="false" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
    <template #toolbar>
      <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Csv</b-button>
    </template>
    <template slot="table-body">
      <data-analysis-dashboard-pivot-view-component ref="cmpDataAnalysisDashboardPivotViewComponent" @afterLoadData="onAfterLoadData"></data-analysis-dashboard-pivot-view-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalysisDashboardPivotViewComponent from "../components/DataAnalysisDashboardPivotViewComponent.vue";
export default {
  components: { SaPageLayout, DataAnalysisDashboardPivotViewComponent },

  data() {
    return {
      idDashboard: null,
      linkback: null,
      pathResource: null,
      showModalLoading: false,
      jsonData: {},
    };
  },
  mounted() {
    let sessionElement = JSON.parse(sessionStorage.getItem("sessionElement"));
    this.idDashboard = sessionElement.idDashboard;
    this.linkback = "/dataanalysisdashboards/view/" + this.idDashboard;
    this.showModalLoading = true;
    this.$refs.cmpDataAnalysisDashboardPivotViewComponent.init(sessionElement.bodyElement);
  },
  methods: {
    onAfterLoadData() {
      this.showModalLoading = false;
    },
    onScaricaCsv() {
      this.$refs.cmpDataAnalysisDashboardPivotViewComponent.onDowloadFileCsv();
    },
  },
};
</script>

<style></style>
